// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__peQfF","auth":"Layout_auth__ucF++"};